var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.62656 0.015625C5.95869 0.0176102 4.3597 0.681094 3.18039 1.86052C2.00108 3.03995 1.33776 4.639 1.33594 6.30688C1.33594 9.60312 6.43969 14.0125 7.02344 14.505L7.62781 15.0156L8.23219 14.505C8.81469 14.0125 13.9197 9.60312 13.9197 6.30688C13.9179 4.63857 13.2542 3.03914 12.0743 1.85964C10.8945 0.68014 9.29487 0.0169485 7.62656 0.015625ZM7.62656 12.5425C5.71094 10.7975 3.20969 7.9625 3.20969 6.30688C3.20969 5.13545 3.67504 4.012 4.50336 3.18367C5.33168 2.35535 6.45513 1.89 7.62656 1.89C8.79799 1.89 9.92144 2.35535 10.7498 3.18367C11.5781 4.012 12.0434 5.13545 12.0434 6.30688C12.0434 7.95937 9.54156 10.7956 7.62656 12.5425Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.62654 8.12125C8.66104 8.12125 9.49967 7.28262 9.49967 6.24812C9.49967 5.21363 8.66104 4.375 7.62654 4.375C6.59204 4.375 5.75342 5.21363 5.75342 6.24812C5.75342 7.28262 6.59204 8.12125 7.62654 8.12125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.126465)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.55c2be0f1e98fe4295cdcca47b5fb1e7.svg";
export { ForwardRef as ReactComponent };